<template>
  <div class="statistics-filtration">
    <IconButton
      button="filters"
      @click="() => isOpen = !isOpen"
    >
      Фильтрация
    </IconButton>

    <div
      v-show="isOpen"
      v-click-outside="closePopup"
      class="statistics-filtration__popup"
    >
      <div class="statistics-filtration__row">
        <span class="statistics-filtration__label">
          По дате:
        </span>
        <DateTimeInput />
      </div>

      <div
        v-if="!hideNameSearch"
        class="statistics-filtration__row"
      >
        <span class="statistics-filtration__label">
          {{ $route.params.type === 'promotions' ? 'По названию акции:' : 'По названию акции/рассылки:' }}
        </span>
        <input
          v-model="name"
          type="text"
        >
      </div>

      <div
        v-if="!hideTagFilter"
        class="statistics-filtration__row"
      >
        <span class="statistics-filtration__label">
          По имени отправителя:
        </span>

        <cm-select
          v-model="providerFilter"
          :options="providerOptions"
          labelKey="Name"
          idKey="PartnerName"
          @open="isSelectOpen = true"
          @close="onSelectClose"
        />
      </div>

      <div
        v-if="!hideProviderFilter"
        class="statistics-filtration__row"
      >
        <span class="statistics-filtration__label">
          По тегам:
        </span>

        <cm-select
          v-model="tagFilter"
          :options="tagOptions"
          @open="isSelectOpen = true"
          @close="onSelectClose"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { convertTypeToInt } from "@/utils/general";

import DateTimeInput from "@/components/statistics/general/DateTimeInput.vue";
import IconButton from "@/manzana_library/components/Elements/IconButton.vue";
import CmSelect from "@/components/library/Form/CmMultipleSelect.vue";

import CampService from "@/services/CampService";

export default {
  name: "StatisticsFiltration",

  components: {
    DateTimeInput,
    IconButton,
    CmSelect,
  },

  props: {
    hideNameSearch: {
      type: Boolean,
      default: false,
    },
    hideTagFilter: {
      type: Boolean,
      default: false,
    },
    hideProviderFilter: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false,
      isSelectOpen: false,
      name: "",
      providerFilter: [],
      providerOptions: [],
      tagFilter: [],
      tagOptions: [],
    };
  },

  watch: {
    name(next) {
      this.setStatFilters({
        key: "name",
        value: next,
      });
    },

    providerFilter(next) {
      this.setStatFilters({
        key: "providerFilter",
        value: next,
      });
    },

    tagFilter(next) {
      this.setStatFilters({
        key: "tagFilter",
        value: next,
      });
    },
  },

  mounted() {
    if (!this.hideNameSearch) {
      this.getTags();
      this.getProviders();
    }
  },

  beforeDestroy() {
    this.resetStatFilters();
  },

  methods: {
    ...mapMutations({
      setStatFilters: "setStatFilters",
      resetStatFilters: "resetStatFilters",
    }),

    onSelectClose() {
      setTimeout(() => this.isSelectOpen = false, 0);
    },

    async getTags() {
      try {
        const res = await CampService.getCampTags();
        this.tagOptions = res.map(i => ({id: i, label: i}));
      } catch (e) {
        console.log(e);
      }
    },

    async getProviders() {
      try {
        this.providerOptions = await CampService.getProviders(
          convertTypeToInt(this.$route.params.type) || "",
        );
      } catch (e) {
        console.log(e);
      }
    },

    closePopup() {
      const isDatePickerClick = event.composedPath().find(pathEl => {
        return pathEl.className === "mx-datepicker-main mx-datepicker-popup";
      });

      if (isDatePickerClick || this.isSelectOpen) return;
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss">
.statistics-filtration {
  position: relative;
  padding-left: 8px;
  padding-top: 20px;
  .icon-button--filters {
    .icon-button__text {
      color: $color_green-new;
      font-size: 15px;
      font-weight: 600;
    }

    &:active {
      text-decoration: none;
    }

    &:hover .icon-button__text,
    &:active .icon-button__text {
      color: darken($color_green-new, 3);
    }
  }

  &__popup {
    background: $color_white;
    border: 1.5px solid rgba(102, 204, 0, 0.8);
    border-radius: 3px;
    max-width: 600px;
    padding: 20px;
    width: 100%;
    position: absolute;
    top: 55px;
    left: 0;
    z-index: 3000;
    .mx-datepicker.mx-datepicker-range {
      width: 100%;
      max-width: 100%;
    }
  }

  &__row {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
  }

  &__label {
    margin-bottom: 10px;
  }

  &__multiple-select {
    .vs__selected-options {
      display: flex;
      flex-direction: row;
    }
    .vs__selected {
      position: relative;
    }
  }
}
</style>